// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FastForwardFilledSvg from "@ant-design/icons-svg/es/asn/FastForwardFilled";
import AntdIcon from '../components/AntdIcon';

var FastForwardFilled = function FastForwardFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FastForwardFilledSvg
  }));
};

FastForwardFilled.displayName = 'FastForwardFilled';
export default React.forwardRef(FastForwardFilled);